import { render, staticRenderFns } from "./teleportation.vue?vue&type=template&id=bc6f3016"
import script from "./teleportation.vue?vue&type=script&lang=js"
export * from "./teleportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports